<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  COBALT,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_COBALT,
} from '~/constants/services/constants'
import cobaltData from '~/constants/price-assessments/unauthorized/cobalt'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_COBALT
const data = {
  product: COBALT,
  productData: cobaltData,
  subscription,
}

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${COBALT.name} Prices`,
})
useHead(seo)
</script>
